module.exports = __webpack_public_path__ + "img/ukjent_driver_med_paavirkningsgrad.a57896a2.jpg";